import React, { useContext } from 'react'
import Modal from '@material-ui/core/Modal'
import { makeStyles } from '@material-ui/core/styles'
import SignInUpForm from 'components/forms/signinup/SignInUpForm'
import SponsoredForm from 'components/forms/signinup/SponsoredForm'
import { modalContext } from 'global/context/sub-contexts/modalContext'

import Backdrop from '@material-ui/core/Backdrop'

import './SignInUpModal.scss'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

const SignInUpModal = () => {
  const modal_context = useContext(modalContext)
  const {
    signInUpModal,
    setSignInUpModal,
    sponsoredModal,
    setSponsoredModal,
    modalContent,
    onLoginSuccess,
  } = modal_context || {}

  const classes = useStyles()
  return (
    <>
      {signInUpModal && (
        <Modal
          tabIndex={1}
          className={classes.modal}
          open={signInUpModal}
          onBackdropClick={() => {
            setSignInUpModal(false)
          }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div>
            <SignInUpForm
              tab={modalContent.args.tab || 0}
              onLoginSuccess={onLoginSuccess}
              onRegistrationSuccess={onLoginSuccess}
            />
          </div>
        </Modal>
      )}
      {sponsoredModal && (
        <Modal
          tabIndex={0}
          className={classes.modal}
          open={sponsoredModal}
          onBackdropClick={() => {
            setSponsoredModal(false)
          }}
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <div>
            <SponsoredForm />
          </div>
        </Modal>
      )}
    </>
  )
}

export default SignInUpModal
